import { render } from "./export-button.vue?vue&type=template&id=0743810b&ts=true"
import script from "./export-button.vue?vue&type=script&lang=ts"
export * from "./export-button.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__